// Base Command - 基础指令类
class BaseCommand {
  constructor(name, chineseName = null, description = '', shouldAutoSave = false, commandManager = null) {
    this.name = name;
    this.chineseName = chineseName;
    this.description = description;
    this.shouldAutoSave = shouldAutoSave;
    this.commandManager = commandManager;
  }

  // 检查指令是否可用
  isAvailable() {
    return true;
  }

  // 获取不可用时的消息
  getUnavailableMessage() {
    return '此指令当前不可用。';
  }

  // 执行指令
  execute(arg) {
    throw new Error('子类必须实现 execute 方法');
  }
}

export { BaseCommand };
